import http from './http'

class Assginor {
  getCurrentEconomicGroup() {
    return http.get('/cedente/current')
  }
}

export default new Assginor()
